<template lang="pug">
  div(style="margin-top:20px")
    v-snackbar(v-model="modifyErrorSnackbar" :timeout="mofifyErrorTimeout") foobar
    v-card(outlined max-width="96%" class="mx-auto" style="padding:10px; ")
      v-layout(row, wrap)
            v-flex(xs12, sm12) 
              h3.headerSection Daftar Tamu
              br
      v-layout(row, wrap, v-for="(item, index) in visitor", :key="index")
        v-flex(xs3, sm3)
          span.mustFill(style="padding-left: 30px") *
            v-text-field.inputDefault(
              style="padding-left: 30px; margin-right: 20px",
              v-model="item.name",
              id="fvisit-nama-tamu"
              placeholder="Nama Tamu",
              :rules='[visitorRules.required]'
            )
        v-flex(xs2, sm2)
          span.mustFill *
            v-text-field.inputDefault(
              style="margin-right: 20px",
              v-model="item.company",
              id="fvisit-nama-company"
              placeholder='Perusahaan',
              :rules='[visitorRules.required]'
            )
        v-flex(xs2, sm2)
          span.mustFill *
            v-text-field.inputDefault(
              style="margin-right: 20px",
              v-model="item.position",
              id="fvisit-nama-jabatan"
              placeholder='Jabatan',
              :rules='[visitorRules.required]'
            )
        v-flex(xs2, sm2)
          span.mustFill *
            v-text-field.inputDefault(
              style="margin-right: 20px",
              v-model="item.email",
              id="fvisit-nama-tamu"
              placeholder='Email',
              :rules='[visitorRules.required, visitorRules.email]'
            )
        v-flex(xs2, sm2)
          span.mustFill *
            v-text-field.inputDefault(
              style="margin-right: 20px",
              v-model="item.phone",
              id="fvisit-nohp"
              placeholder='No Handphone',
              maxlength='15'
              counter
              :rules='[visitorRules.required, visitorRules.phone]'
            )
        v-flex(xs1, sm1)
          v-btn.mt-5(icon, color="red", small @click='handleDeleteVisitor(index)') 
            v-icon(title="Edit") mdi-close-box
      v-layout(row, wrap)
    v-form(ref="form" v-model="valid" lazy-validation)
      v-card(outlined max-width="96%" class="mx-auto" style="padding:10px;margin-top:20px ")
        v-layout(row, wrap)
              v-flex(xs12, sm12) 
                h3.headerSection Input Tamu
                br
        v-layout(row wrap )
          v-flex(xs3, sm3)
            span.mustFill(style="padding-left: 30px") *
              v-text-field.inputDefault(
                style="padding-left: 30px; margin-right: 20px",
                v-model="visitorName",
                placeholder="Nama Tamu",
                id="fvisit-nama-tamu"
                :disabled="isTamuMaxed"
                :rules='[visitorRules.required]'
              )
          v-flex(xs2, sm2)
              span.mustFill *
                v-text-field.inputDefault(
                  style="margin-right: 20px",
                  v-model="visitorCompany",
                  id="fvisit-company"
                  placeholder="Perusahaan"
                  :disabled="isTamuMaxed"
                  :rules='[visitorRules.required]'
                )
          v-flex(xs2, sm2)
            span.mustFill *
              v-text-field.inputDefault(
                style="margin-right: 20px",
                v-model="visitorPosition",
                placeholder="Jabatan",
                id="fvisit-jabatan"
                :disabled="isTamuMaxed"
                :rules='[visitorRules.required]'
              )
          v-flex(xs2, sm2)
            span.mustFill *
              v-text-field.inputDefault(
                style="margin-right: 20px",
                v-model="visitorEmail",
                placeholder="Email",
                id="fvisit-email",
                :disabled="isTamuMaxed"
                :rules='[visitorRules.required, visitorRules.email]'
              )
          v-flex(xs2, sm2)
            span.mustFill *
              v-text-field.inputDefault(
                style="margin-right: 20px",
                v-model="visitorNoPhone",
                id="fvisit-nohp-visitor"
                placeholder="No Handphone"
                maxlength='15'
                counter
                :disabled="isTamuMaxed"
                :rules='[visitorRules.required, visitorRules.phone]'
              )
        v-layout(row, wrap style="margin-top: 20px")
          v-flex(xs11, sm11)
            span.mustFill 
              v-btn(
                color="#4CAF50",
                style="color: white; float: right; margin-right: 20px",
                @click="handleListTamu"
                :disabled="isTamuMaxed"
              ) Tambah Tamu
              br
              br
      v-layout(row, wrap style="margin-top: 20px; padding:20px")
        v-flex(xs1, sm1  class="d-flex justify-end")
          v-btn(text color="primary" style="width:90%" @click="handleBackPage") Cancel
        v-flex(xs1, sm1 class="d-flex justify-end")
          v-btn(color="primary" style="width:90%" @click="handleSubmit") Submit
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
export default {
  name: "FormVisitor",
  data() {
    return {
      modifyErrorSnackbar: false,
      modifyErrorTimeout: 500,
      visitor: [],
      valid: true,
      visitorName: "",
      visitorCompany: "",
      visitorPosition: "",
      visitorEmail: "",
      visitorNoPhone: "",
      ipNo :"",
    };
  },
  mounted() {
    this.$store.dispatch("fetchMyPermit")
    this.ipNo = this.listDataVisitor.ipNo
    this.visitor = this.listDataVisitor.ipVisitors
  },
  computed: {
  ...mapState(["API_URL","listDataVisitor", "visitorRules"]),
  
  isTamuMaxed() {
      return this.visitor.length >= 10;
    },
  },
  methods: {
    handleListTamu() {
       this.$refs.form.validate();
      if(this.$refs.form.validate() === true) {
        this.visitor.push({
          name: this.visitorName,
          company: this.visitorCompany,
          position: this.visitorPosition,
          email: this.visitorEmail,
          phone: this.visitorNoPhone,
        });
          this.visitorName = "",
          this.visitorCompany = "",
          this.visitorNoPhone = "",
          this.visitorEmail = "",
          this.visitorPosition = ""
      }
    },
    handleDeleteVisitor(value){
       this.visitor.splice(value, 1);
    },
    handleBackPage(){
      this.$router.push("/my-visitor");
    },
    handleSubmit(){
      const formData = {
        ipNo : this.ipNo,
        visitors : this.visitor
      }
      const config = {
        method:  "post",
        url: `${this.API_URL}/v1/requests/addVisitor`,
        headers: {"Content-Type": "application/json", "Authorization": `Bearer ${this.$store.state.token}`},
        data: formData
      };

      axios(config).then(res => {
       console.log(res)
       this.$router.push("/my-visitor");
      }).catch(err =>{
        console.log(err.response.data)
        this.$router.push("/my-visitor");
      });
    }
  },
  watch: {

  }
};
</script>

<style>
</style>